import React, {
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { Link } from "react-router-dom";
import { getTrans as T } from "../../../Shared/Language";
import {
  approveLeaveStatus,
  getLeaveDetailsList,
  rejectLeaveStatus,
} from "./leaveService";
import { TostMsg } from "../../../App";
import { LazyImage } from "../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import { orgSettings } from "../../../Services/Global-Services/GlobalServices";
import { Paginator } from "primereact/paginator";
import LeaveManagerReport from "./CommonComponents/LeaveManagerReport";
import LeaveNavBarItems from "./CommonComponents/LeaveNavBarItems";
import { Dropdown } from "primereact/dropdown";
import { getEmployeeList } from "../EmployeeList/Service/employeeService";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
const ComponentLoader = React.lazy(() =>
  import("../../../Shared/Sidebar/ComponentLoader")
);

function TeamLeave() {
  const leaveRequestData = useSelector((state) => state.leave.leaveRequestData);
  const dispatch = useDispatch();
  const [leaveData, setLeaveData] = useState([]);
  const toster = useContext(TostMsg);
  const [showAllUserDataModel, setshowAllUserDataModel] = useState([]);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [resonValue, setResonValue] = useState("");
  const [Isloading, setIsloading] = useState(false);
  const [masterSystemAlertData, setMasterSystemAlertData] = useState([]);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [pageNumber, serPageNumber] = useState(1);
  const [pageSize, serPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [selectedHierarchyValue, setSelectedHierarchyValue] = useState("2");
  const [selectedStatusValue, setselectedStatusValue] = useState("U");
  let Sdate = null;
  let EDate = null;
  const [filterStartDate, setFilterStartDate] = useState(Sdate);
  const [filterEndDate, setFilterEndDate] = useState(EDate);
  const [selectedEmployeId, setSelectedEmployeId] = useState(0);
  const [employeeList, setEmployeeList] = useState(null);
  const [showLeaveHistory, setShowLeaveHistory] = useState(null);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const [noData, setNoData] = useState([]);
  const defaultImage = "/images/placeholder_profile.png";
  let ApllyForOtherEmployeeId;
  const location = useLocation();
  useEffect(() => {
    if (leaveRequestData) {
      ApllyForOtherEmployeeId = leaveRequestData?.EmpId;
      setSelectedEmployeId(leaveRequestData?.EmpId);
      setSelectedHierarchyValue("3");
      setselectedStatusValue("P");
      getEmployeeIdData(0);
      OrgSettings(leaveRequestData);
      GetMasterSystemAlertList("Team_Leave_SubText", 1);
    } else {
      ApllyForOtherEmployeeId = JSON.parse(
        localStorage.getItem("User") || "{}"
      )?.EmpId;
      getEmployeeIdData(2);
      OrgSettings(null);
      GetMasterSystemAlertList("Team_Leave_SubText", 1);
      GetMasterSystemAlertList("Leave_logged", 2);
    }
  }, [leaveRequestData]);

  const OrgSettings = useCallback(async (leaveRequestData) => {
    let param = {
      OrgId: userDetails?.OrgId,
    };
    try {
      let responce = await orgSettings(param);
      let StartDate = responce?.Data?.filter(
        (element) => element.KeyName == "LeaveFilterStartDate"
      );
      if (leaveRequestData) {
        Sdate = new Date(leaveRequestData?.StartDate)
          ?.toISOString()
          ?.split("T")[0];
        setFilterStartDate(Sdate);
        EDate = new Date(leaveRequestData?.EndDate)
          ?.toISOString()
          ?.split("T")[0];
        setFilterEndDate(EDate);
      } else {
        if (StartDate[0]?.Value != null) {
          Sdate = new Date(StartDate[0]?.Value)?.toISOString()?.split("T")[0];
        } else {
          Sdate = new Date(new Date() - 30 * 24 * 60 * 60 * 1000)
            ?.toISOString()
            ?.split("T")[0];
        }
        setFilterStartDate(Sdate);
        let EndDate = responce?.Data?.filter(
          (element) => element?.KeyName == "LeaveFilterEndDate"
        );
        if (EndDate[0]?.Value != null) {
          EDate = new Date(EndDate[0]?.Value)?.toISOString()?.split("T")[0];
        } else {
          EDate = new Date()?.toISOString()?.split("T")[0];
        }
        setFilterEndDate(EDate);
      }
    } catch (error) {
      Sdate = new Date(new Date() - 30 * 24 * 60 * 60 * 1000)
        ?.toISOString()
        ?.split("T")[0];
      EDate = new Date()?.toISOString()?.split("T")[0];
      setFilterStartDate(Sdate);
      setFilterEndDate(EDate);
    }
  }, []);

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  const getLeaveData = useCallback(async (pageNumber, pageSize) => {
    setIsloading(true);
    let FilterendOfTheDay = new Date(filterEndDate);
    FilterendOfTheDay?.setUTCHours(23, 59, 59, 999);
    const FilterEndDate = FilterendOfTheDay?.toISOString();
    const param = {
      LoggedInEmpId: userDetails?.EmpId,
      OrgId: userDetails?.OrgId,
      EmpId: selectedEmployeId,
      LeaveId: 0,
      leavecategory: selectedStatusValue,
      HierarchyTypeId: Number(selectedHierarchyValue),
      FilterStartDate:
        new Date(filterStartDate).toISOString() ?? Sdate ?? "2008-10-01",
      FilterEndDate: FilterEndDate,
      pageNumber: pageNumber,
      pageSize: pageSize,
    };
    try {
      const data = await getLeaveDetailsList(param);
      setTotalRecords(data?.Data[0]?.TotalCount);
      setLeaveData(
        data?.Data?.map((item) => ({
          ...item,
          showFull: false,
        }))
      );
      setIsloading(false);
    } catch {
      setIsloading(false);
      toster.current.error(ERROR_LIST.DefaultError);
    }
  });

  useEffect(() => {
    setTimeout(() => {
      getLeaveData(pageNumber, pageSize);
    }, 500);
  }, [
    selectedEmployeId,
    selectedStatusValue,
    selectedHierarchyValue,
    filterStartDate,
    filterEndDate,
  ]);

  const handleResonChange = (e) => {
    setResonValue(e?.target?.value);
  };

  const handleSubmit = useCallback(
    async (submitType) => {
      if (submitType == "Approved") {
        setIsloading(true);

        const body = {
          id: showAllUserDataModel?.Id ?? 0,
          RequestorId: showAllUserDataModel?.EmpId,
          Reason: resonValue?.trim() ?? "No Reson",
        };
        try {
          await approveLeaveStatus(body);
          getLeaveData(pageNumber, pageSize);
          setselectedStatusValue(selectedStatusValue);
          GetMasterSystemAlertList("Status Updated", 0);
          document.querySelector("#pending-request .btn-close")?.click();
          setResonValue("");
          setIsloading(false);
        } catch (err) {
          toster.current.error(ERROR_LIST.DefaultError);
          setIsloading(false);
        }
      } else if (submitType == "Reject") {
        setIsloading(true);
        const body = {
          id: showAllUserDataModel?.Id ?? 0,
          RequestorId: showAllUserDataModel?.EmpId,
          Reason: resonValue?.trim() ?? "No Reson",
        };
        try {
          await rejectLeaveStatus(body);
          document.querySelector("#pending-request .btn-close")?.click();
          getLeaveData(pageNumber, pageSize);
          setselectedStatusValue(selectedStatusValue);
          setResonValue("");
          GetMasterSystemAlertList("Status Updated", 0);
          setIsloading(false);
        } catch (err) {
          toster.current.error(ERROR_LIST.DefaultError);
          setIsloading(false);
        }
      }
    },
    [showAllUserDataModel, resonValue]
  );

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setMasterSystemAlertData(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setNoData(msg?.Desc);
      }
    });
  }, []);

  const onPageChange = async (event) => {
    setFirst(event.first);
    setRows(event.rows);
    await getLeaveData(event.page + 1, event.rows);
  };

  const [options] = useState([
    { value: "2", label: "Direct Report" },
    { value: "3", label: "Complete Hierarchy" },
  ]);

  const [LeaveStatus] = useState([
    { value: "U", label: "Upcoming" },
    { value: "C", label: "Archived" },
    { value: "P", label: "Pending" },
  ]);

  const setSelectHierarchy = (event) => {
    getEmployeeIdData(event.target.value);
  };

  //For get the employee data.
  const getEmployeeIdData = useCallback(async (HierarchyValue) => {
    var params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: Number(HierarchyValue) ?? 0,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      IsSuggestedOnly: 0,
      pageNumber: 1,
      pageSize: 10000,
      EmployeeId: ApllyForOtherEmployeeId ?? userDetails?.EmpId,
      IsSuggestedOnly: 0,
    };
    try {
      let employeesList = await getEmployeeList(params);
      let UpdatedemployeesList = employeesList?.Data?.toSpliced(0, 0, {
        id: 0,
        EmpId: 0,
        FullName: "All Employees",
      });
      setEmployeeList(UpdatedemployeesList);
    } catch (error) {
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }, []);

  const employeeOptionTemplate = (option) => {
    return (
      <div className="flex align-items-center gap-2 ticket-file-attach__items_detail">
        <LazyImage
          alt={option?.FullName}
          src={option?.ProfileImage || defaultImage}
          onError={handleImageError}
          width="32"
        />
        <span>
          {option?.FullName}
          {option?.UserName?.length > 0 && ","}
        </span>
        <span>
          {option?.UserName}
          {option?.CurrentDesignation?.length > 0 && ","}
        </span>
        <span>{option?.CurrentDesignation}</span>
      </div>
    );
  };

  const handleToggle = (index) => {
    if (showLeaveHistory === index) {
      setShowLeaveHistory(null);
    } else {
      setShowLeaveHistory(index);
    }
  };

  const showFull = (id, expand) => {
    setLeaveData((prev) =>
      prev.map((item) =>
        item.Id === id ? { ...item, showFull: expand } : item
      )
    );
  };

  return (
    <div>
      <div id="circular-menu" className="circular-menu">
        <a className="floating-btn">
          <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
          <i aria-hidden="true" className="fa fa-times"></i>
        </a>
        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="languages-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </a>
          <Link to="" className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="activity-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-grid"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </a>
        </div>
      </div>
      {/* <!-- row --> */}
      <div className="container-fluid position-relation">
        <div className="row g-3">
          <div className="form-head ">
            <div className="row">
              <div className="col-lg-5">
                <div className="">
                  <h2 className="font-w600 mb-0">{T("Team Leaves")}</h2>
                  <p className="sub-description-p">
                    Track your team’s time off to plan and manage work
                    efficiently.
                  </p>
                  {/* <p className="text-light">{masterSystemAlertData[0]?.Desc}</p> */}
                </div>
              </div>
              <div className="col-lg-7">
                <div className="rightside-tabs">
                  <LeaveNavBarItems />
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-8">
            <div className="leave-card tile-grid tile-grid-v1">
              <div className="tab-tabsa2">
                <div className="form-group d-gridcss mb-0">
                  <label>Start Date</label>
                  <input
                    type="date"
                    name="startDate"
                    onClick={(e) =>
                      e.target.showPicker && e.target.showPicker()
                    }
                    className="form-control"
                    placeholder="Start Date"
                    onFocus="(this.type='date')"
                    value={filterStartDate}
                    onChange={(e) => setFilterStartDate(e.target.value)}
                  />
                  <label>End Date</label>
                  <input
                    type="date"
                    name="endDate"
                    onClick={(e) =>
                      e.target.showPicker && e.target.showPicker()
                    }
                    className="form-control"
                    placeholder="End Date"
                    value={filterEndDate}
                    onChange={(e) => setFilterEndDate(e.target.value)}
                  />
                </div>
                <div className="widthdiv">
                  <Dropdown
                    value={selectedStatusValue}
                    onChange={(e) => {
                      const selectedOption = e.value;
                      setselectedStatusValue(selectedOption);
                    }}
                    options={LeaveStatus}
                    optionLabel="label"
                    placeholder="Choose"
                    checkmark={true}
                    highlightOnSelect={false}
                  />
                </div>

                <div className="widthdiv">
                  <Dropdown
                    value={selectedHierarchyValue}
                    onChange={(e) => {
                      setSelectHierarchy(e);
                      setSelectedHierarchyValue(e.target.value);
                    }}
                    options={options}
                    optionLabel="label"
                    placeholder="Choose"
                    checkmark={true}
                    highlightOnSelect={false}
                  />
                </div>
                <div className="widthdiv">
                  <Dropdown
                    value={selectedEmployeId}
                    onChange={(e) => setSelectedEmployeId(e.target.value)}
                    filter={true}
                    options={employeeList}
                    optionLabel="FullName"
                    optionValue="EmpId"
                    itemTemplate={employeeOptionTemplate}
                    placeholder="Choose"
                    checkmark={true}
                    highlightOnSelect={false}
                  />
                </div>
              </div>
              {leaveData?.map((leave, index) => {
                return (
                  <div key={index}>
                    <div className="leave-cards">
                      <div className="" key={index}>
                        <div className="team-leavecard-list">
                          <div className="leave-container">
                            <img
                              src="/images/org-img/leave/upcoming1.png"
                              className="w-100  leave-image"
                            />
                            <div className="leave-count-overlay">
                              {leave?.Days}
                            </div>
                          </div>
                          <div className="leave-body">
                            <div class="leave-type-row">
                              <span class="leave-type unplanned"> {leave?.LeaveTypeName}</span>
                              <span className="emp-name">
                                <LazyImage
                                  className="avatar"
                                  src={leave?.ProfileImage}
                                  data-demo-src="/images/avatar/1.jpg"
                                  alt=""
                                  data-user-popover="25"
                                  data-target="webuiPopover6"
                                  width="30px"
                                />{" "}
                                <p>{leave?.EmployeeName}</p>
                              </span>
                            </div>
                            <p className="leave-description">
                              {leave?.Reason?.length > 75 &&
                                !leave?.showFull ? (
                                <>
                                  {leave?.Reason.slice(0, 75)}...
                                  <span
                                    style={{
                                      color: "red",
                                      cursor: "pointer",
                                      fontSize: "12px",
                                    }}
                                    onClick={() =>
                                      showFull(leave.Id, true)
                                    }
                                  >
                                    read more
                                  </span>
                                </>
                              ) : (
                                leave?.Reason
                              )}
                              {leave?.showFull && (
                                <span
                                  style={{
                                    color: "red",
                                    cursor: "pointer",
                                    fontSize: "12px",
                                  }}
                                  onClick={() =>
                                    showFull(leave.Id, false)
                                  }
                                >
                                  &nbsp; read less
                                </span>
                              )}
                            </p>
                            <div className="leave-meta">
                              <div className="meta-item">
                                <span className="meta-label">From:</span>
                                <span className="meta-value">{moment(leave?.StartDate).format(
                                  "MMM DD YYYY"
                                )}</span>
                              </div>
                              <div className="meta-item">
                                <span className="meta-label">To:</span>
                                <span className="meta-value">{moment(leave?.EndDate).format("MMM DD YYYY")}</span>
                              </div>
                              <div className="meta-item">
                                <span className="meta-label">Half Day:</span>
                                <span className="meta-value">
                                  {leave?.IsHalfDay == false && (
                                    <span>No</span>
                                  )}{" "}
                                  {leave?.IsHalfDay == true &&
                                    leave?.HalfPreference == "1" && (
                                      <span>First Half</span>
                                    )}{" "}
                                  {leave?.IsHalfDay == true &&
                                    leave?.HalfPreference == "2" && (
                                      <span>Second Half</span>
                                    )}
                                </span>
                              </div>

                              <span class="status-badge approved ml-auto">
                                {leave?.LeaveStatusId === 101 && (
                                  <p
                                    className="pending-status-btn-click mb-0"
                                    data-bs-toggle="modal"
                                    data-bs-target="#pending-request"
                                    onClick={() => {
                                      // setResonValue("");
                                      setshowAllUserDataModel(leave);
                                    }}
                                  >
                                    <a>
                                      <i
                                        className="fa fa-clock-o"
                                        aria-hidden="true"
                                      ></i>{" "}
                                      Approve/Reject
                                    </a>
                                  </p>
                                )}
                                <div className="innerdiv">
                                  {leave?.LeaveStatusId === 103 && (
                                    <a className="approved-status-btn">
                                      <i
                                        className="fa fa-check"
                                        aria-hidden="true"
                                      ></i>{" "}
                                      {leave?.LeaveStatusName}
                                    </a>
                                  )}
                                  {leave?.LeaveStatusId === 102 && (
                                    <a className="approved-status-btn">
                                      <i
                                        className="fa fa-check-o"
                                        aria-hidden="true"
                                      ></i>{" "}
                                      {leave?.LeaveStatusName}
                                    </a>
                                  )}
                                  {leave?.LeaveStatusId === 104 && (
                                    <a className="Rejected">
                                      <i
                                        className="fa fa-clock-o"
                                        aria-hidden="true"
                                      ></i>{" "}
                                      {leave?.LeaveStatusName}
                                    </a>
                                  )}
                                </div>
                              </span>
                            </div>
                            {/* <div className="innerdiv d-flex align-items-center">
                                <div className="media-body px-0"> */}
                            {/* <span className="mt-0 mb-3 datecol">
                                    {leave?.LeaveTypeName}
                                  </span> */}
                            {/* <p className="leave-description">
                                      {leave?.Reason?.length > 15 &&
                                        !leave?.showFull ? (
                                        <>
                                          {leave?.Reason.slice(0, 15)}...
                                          <span
                                            style={{
                                              color: "red",
                                              cursor: "pointer",
                                              fontSize: "12px",
                                            }}
                                            onClick={() =>
                                              showFull(leave.Id, true)
                                            }
                                          >
                                            read more
                                          </span>
                                        </>
                                      ) : (
                                        leave?.Reason
                                      )}
                                      {leave?.showFull && (
                                        <span
                                          style={{
                                            color: "red",
                                            cursor: "pointer",
                                            fontSize: "12px",
                                          }}
                                          onClick={() =>
                                            showFull(leave.Id, false)
                                          }
                                        >
                                          &nbsp; read less
                                        </span>
                                      )}
                                    </p> */}
                            {/* <div className="emp-name">
                                    <LazyImage
                                      className="avatar"
                                      src={leave?.ProfileImage}
                                      data-demo-src="/images/avatar/1.jpg"
                                      alt=""
                                      data-user-popover="25"
                                      data-target="webuiPopover6"
                                      width="30px"
                                    />{" "}
                                    <p>{leave?.EmployeeName}</p>
                                  </div> */}
                            {/* </div>
                              </div> */}
                            {/* <div className="innerdiv d-flex align-items-center">
                                <div className="d-flex">
                                  <p className="me-2 mb-0">
                                    <b>From:</b>&nbsp;
                                    {moment(leave?.StartDate).format(
                                      "MMM DD YYYY"
                                    )}
                                  </p>
                                  &nbsp;&nbsp;
                                  <p className="me-2 mb-0">
                                    <b>To:</b>&nbsp;
                                    {moment(leave?.EndDate).format("MMM DD YYYY")}
                                  </p>
                                  &nbsp;&nbsp;
                                  <p className="mb-0">
                                    <b>Half Day:</b>&nbsp;
                                    {leave?.IsHalfDay == false && (
                                      <span>No</span>
                                    )}{" "}
                                    {leave?.IsHalfDay == true &&
                                      leave?.HalfPreference == "1" && (
                                        <span>First Half</span>
                                      )}{" "}
                                    {leave?.IsHalfDay == true &&
                                      leave?.HalfPreference == "2" && (
                                        <span>Second Half</span>
                                      )}
                                  </p>
                                </div>
                              </div> */}
                            {/* <div>
                              {leave?.LeaveStatusId === 101 && (
                                <p
                                  className="pending-status-btn-click mb-0"
                                  data-bs-toggle="modal"
                                  data-bs-target="#pending-request"
                                  onClick={() => {
                                    // setResonValue("");
                                    setshowAllUserDataModel(leave);
                                  }}
                                >
                                  <a>
                                    <i
                                      className="fa fa-clock-o"
                                      aria-hidden="true"
                                    ></i>{" "}
                                    Approve/Reject
                                  </a>
                                </p>
                              )}
                              <div className="innerdiv">
                                {leave?.LeaveStatusId === 103 && (
                                  <a className="approved-status-btn">
                                    <i
                                      className="fa fa-clock-o"
                                      aria-hidden="true"
                                    ></i>{" "}
                                    {leave?.LeaveStatusName}
                                  </a>
                                )}
                                {leave?.LeaveStatusId === 102 && (
                                  <a className="approved-status-btn">
                                    <i
                                      className="fa fa-clock-o"
                                      aria-hidden="true"
                                    ></i>{" "}
                                    {leave?.LeaveStatusName}
                                  </a>
                                )}
                                {leave?.LeaveStatusId === 104 && (
                                  <a className="Rejected">
                                    <i
                                      className="fa fa-clock-o"
                                      aria-hidden="true"
                                    ></i>{" "}
                                    {leave?.LeaveStatusName}
                                  </a>
                                )}
                              </div>
                            </div> */}
                          </div>
                          <div
                            className="innerdiv show-more"
                            onClick={() => handleToggle(index)}
                          >
                            {showLeaveHistory === index ? (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-chevron-down"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                                />
                              </svg>
                            ) : (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-chevron-up"
                                viewBox="0 0 16 16"
                              >
                                {" "}
                                <path
                                  fillRule="evenodd"
                                  d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z"
                                />
                              </svg>
                            )}
                          </div>
                        </div>
                        {showLeaveHistory === index && (
                          <div className="my-leavedetail-view">
                            <div class="timeline-note">Leave Activity Timeline</div>
                            {leave?.EmpLeaveHistory?.length > 0 ? (
                              leave?.EmpLeaveHistory?.reverse()?.map(
                                (history, index) => (
                                  <div key={history?.Id}>
                                    <ul className="timeline">
                                      <li className="timeline-inverted">
                                        <div className="timeline-badge">
                                          1
                                        </div>
                                        <div className="timeline-panel">
                                          <div className="flex-container flex-around">
                                            <div className="timeline-heading">
                                              <h4 className="timeline-title">
                                                {history?.ModifiedByName}
                                              </h4>
                                              {history?.LeaveStatusName === "Applied" && history?.Reason ? (
                                                <p className="timeline-title">{history.Reason}</p>
                                              ) : history?.Comments ? (
                                                <p className="timeline-title">{history.Comments}</p>
                                              ) : null}
                                               {/* {history?.CreatedBy === history?.ModifiedBy ? (
                                                history?.Reason?.length > 0 && (
                                                  <p className="timeline-title">
                                                    {history.Reason}
                                                  </p>
                                                )
                                              ) : (
                                                history?.Comments?.length > 0 && (
                                                  <p className="timeline-title">
                                                    {history.Comments}
                                                  </p>
                                                )
                                              )} */}
                                              <h5 className="leavestatus-timeline">
                                                <i
                                                  className="fa fa-clock-o"
                                                  aria-hidden="true"
                                                ></i>
                                                {history?.LeaveStatusName}
                                                <span>
                                                  on{" "}
                                                  {moment(
                                                    history?.ModifiedDate
                                                  ).format(
                                                    "MMM DD YYYY"
                                                  )}{" "}
                                                  (
                                                  {new Date(
                                                    history?.ModifiedDate
                                                  ).toLocaleTimeString([], {
                                                    hour: "numeric",
                                                    minute: "2-digit",
                                                  })}
                                                  )
                                                </span>
                                              </h5>
                                            </div>
                                            <div className="timeline-clock">
                                              <p>
                                                <i className="glyphicon glyphicon-time"></i>
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                )
                              )
                            ) : (
                              <div>No Leave History Found.</div>
                            )}
                            <div className="remain-balance">
                              <div class="stat-card">
                                <div class="stat-label">Average leave</div>
                                <div class="stat-value">3</div>
                              </div>
                              <div class="stat-card">
                                <div class="stat-label">Recent leave</div>
                                <div class="stat-value">—</div>
                              </div>
                              <div class="stat-card">
                                <div class="stat-label">Leave balance</div>
                                <div class="stat-value balance">10</div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
              {leaveData?.length === 0 || leaveData?.length == null ? (
                <div className="card">
                  <div className="leave-notfound">
                    <img src="/images/no-data-found/teamLeave.png" />
                    <p>{noData}</p>
                  </div>
                </div>
              ) : (
                <div className="card pagination-css">
                  <Paginator
                    first={first}
                    rows={rows}
                    totalRecords={totalRecords}
                    rowsPerPageOptions={[10, 20, 30]}
                    onPageChange={onPageChange}
                  />
                </div>
              )}
            </div>
          </div>
          <div className="col-xl-4">
            <div className="row sidecarddd">
              <div className="col-xl-12">
                <LeaveManagerReport />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="pending-request">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content pendingleaves">
            <div className="modal-header">
              <img
                src="/images/org-img/leave/popup-backimg.png"
                className="backimg"
              />
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
              <div className="img">
                <img src="/images/org-img/leave/pending.png" />
              </div>
            </div>

            <div className="modal-body text-center">
              <strong className="modal-title d-block">Pending Request</strong>
              <div className="inner">
                <div className="h-avatar">
                  <LazyImage
                    className="avatar"
                    src={userDetails?.ProfileImage}
                    alt="Avatar"
                  />
                </div>
                <div className="para-detail">
                  <span className="name-p">
                    {showAllUserDataModel?.EmployeeName}
                  </span>
                  Applied
                  <span>
                    <b>From </b>
                    {moment(showAllUserDataModel?.StartDate).format(
                      "MMM DD YYYY"
                    )}
                  </span>
                  <span>
                    <b>To </b>
                    {moment(showAllUserDataModel?.EndDate).format(
                      "MMM DD YYYY"
                    )}
                  </span>
                  <span>
                    with
                    {showAllUserDataModel?.IsHalfDay == false && (
                      <span>no</span>
                    )}{" "}
                    {showAllUserDataModel?.IsHalfDay == true &&
                      showAllUserDataModel?.HalfPreference == "1" && (
                        <span>First</span>
                      )}{" "}
                    {showAllUserDataModel?.IsHalfDay == true &&
                      showAllUserDataModel?.HalfPreference == "2" && (
                        <span>Second</span>
                      )}{" "}
                    <b>Half Day </b>
                  </span>
                </div>
              </div>

              <label className="mt-3">Reason</label>
              <textarea
                rows="2"
                cols="1"
                onChange={(e) => {
                  setResonValue(e.target.value);
                }}
                className={`form-control`}
                value={resonValue}
                maxLength={500}
              ></textarea>
              <div
                style={{
                  textAlign: "right",
                  fontSize: "12px",
                  position: "absolute",
                  right: "43px",
                  bottom: "17px",
                  color: resonValue.length === 500 ? "red" : "#555",
                }}
              >
                {resonValue.length}/{500}
              </div>
            </div>

            <div className="modal-footer m-auto">
              <button
                type="button"
                className="cancelbtn-click"
                onClick={() => handleSubmit("Reject")}
              >
                Reject
              </button>
              <button
                type="button"
                onClick={() => handleSubmit("Approved")}
                className="savebtn-click"
              >
                Accept
              </button>
            </div>
          </div>
        </div>
      </div>
      {Isloading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
}

export default TeamLeave;
